import { StatusBar } from "native-base";

export default StatusBar;